import type { ButtonVariant } from '@heidi/design-system/button';

import {
  CLINICIAN_MAX_CREDIT_POPOVER_BUTTON_CLASS,
  CLINICIAN_MAX_CREDIT_POPOVER_PROGRESS_CLASS,
  CLINICIAN_MAX_UPGRADE_TRIGGER_BUTTON_CLASS,
  CLINICIAN_MAX_UPGRADE_TRIGGER_ICON_CLASS,
} from '../clinician-max-upgrade-theme';
import { creditUsagePopoverMessages } from './credit-usage-popover-messages';
import type { CreditUsagePopoverPlan } from './types';

type CreditUsagePopoverTheme = {
  buttonVariant: ButtonVariant;
  buttonClassName?: string;
  progressIndicatorClass: string;
  popoverProgressIndicatorClass?: string;
  triggerIconClass: string;
  triggerButtonClass?: string;
};

type CreditUsagePopoverPreset = {
  theme: CreditUsagePopoverTheme;
  planName: typeof creditUsagePopoverMessages.clinicianMaxPlanName;
};

export const CREDIT_USAGE_POPOVER_PRESETS = {
  clinicianMax: {
    theme: {
      buttonVariant: 'secondary',
      buttonClassName: CLINICIAN_MAX_CREDIT_POPOVER_BUTTON_CLASS,
      progressIndicatorClass: '[&>div]:bg-background-primary',
      popoverProgressIndicatorClass: CLINICIAN_MAX_CREDIT_POPOVER_PROGRESS_CLASS,
      triggerIconClass: CLINICIAN_MAX_UPGRADE_TRIGGER_ICON_CLASS,
      triggerButtonClass: CLINICIAN_MAX_UPGRADE_TRIGGER_BUTTON_CLASS,
    },
    planName: creditUsagePopoverMessages.clinicianMaxPlanName,
  },
  practiceMax: {
    theme: {
      buttonVariant: 'pro_plus',
      progressIndicatorClass: '[&>div]:bg-tier-practice',
      // The sidebar trigger marks the usage surface, not the tier, so both
      // plans share the Heidi 2 blue rather than splitting pro / practice.
      triggerIconClass: CLINICIAN_MAX_UPGRADE_TRIGGER_ICON_CLASS,
      triggerButtonClass: CLINICIAN_MAX_UPGRADE_TRIGGER_BUTTON_CLASS,
    },
    planName: creditUsagePopoverMessages.practiceMaxPlanName,
  },
} as const satisfies Record<CreditUsagePopoverPlan, CreditUsagePopoverPreset>;
